import React from 'react'
import PropTypes from 'prop-types'
import { Card as AntCard } from 'antd'
import './card.scss'

const Card = ({
  title,
  extra,
  children,
  bordered = true,
  hoverable = false,
  loading = false,
  className = '',
  ...props
}) => {
  const cardClass = `app-card ${className}`

  return (
    <AntCard
      title={title}
      extra={extra}
      bordered={bordered}
      hoverable={hoverable}
      loading={loading}
      className={cardClass}
      {...props}
    >
      {children}
    </AntCard>
  )
}

Card.propTypes = {
  title: PropTypes.node,
  extra: PropTypes.node,
  children: PropTypes.node,
  bordered: PropTypes.bool,
  hoverable: PropTypes.bool,
  loading: PropTypes.bool,
  className: PropTypes.string
}

export default Card
